window.shippingRates = {
  "DE": { price: 1.90, delivery: "2–5" },
  "AT": { price: 2.90, delivery: "3–6" },
  "CH": { price: 4.90, delivery: "3–6" },
  "FR": { price: 6.90, delivery: "4–8" },
  "ES": { price: 6.90, delivery: "4–8" },
  "IT": { price: 6.90, delivery: "4–8" },
  "US": { price: 9.90, delivery: "8–13" },
  "FI": { price: 4.99, delivery: "4–9" },
  "SK": { price: 5.95, delivery: "4–9" },
  "SI": { price: 5.95, delivery: "4–9" },
  "DEFAULT": { price: 9.90, delivery: "8–15" }
};

